import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import NotFound from "../../components/not-found/NotFound";
import ViewListRoundedIcon from "@mui/icons-material/ViewListRounded";
import { Link, useSearchParams } from "react-router-dom";
import IconButton from "../../components/Button/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import BlockIcon from "@mui/icons-material/Block";
import Switch from "../../components/Switch/Switch";
import { SecondaryButton } from "../../components/Button/Button";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { DatePicker, Select } from "../../components/Form";
import { toast } from "sonner";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import useDebounce from "../../hooks/useDebounce";
// import { getOrderApi } from '../../services/orderManagement'
import { IoSearch } from "react-icons/io5";
import profileImage from "../../Assests/image/profile_not_found.png";
import { user } from "../../routes/route";
import { getLocalStorage, setLocalStorage } from "../../config/config";
import {
  getUserListApi,
  getUserListApimarketing,
  logoutUserFromAllDevice,
  sendOtpAPi,
} from "../../services/userManagement";
import findSerialNumber from "../../utils/findSerialNumber";

import { toastMessage } from '../../utils/toastMessage'
import { fatchCategoryApi } from '../../services/categoryManagement'
import { charLimit } from '../../utils/charLimit'
import common from '../../routes/common'
import UserStatus from "../userManagement/UserStatus";
import { dateFormat, dateFormatUtc } from '../../utils/dateFormat'
import { ConsultationCount, gender } from '../../utils/genderList'
import scrollToUp from '../../utils/scrollToUp'
import { CapitalizeFirstWord } from '../../utils/CapitalizeFirstWord'
import Loader from '../../comman/Loader'
import useDownloadWithPassword from '../../hooks/useDownloadWithPassword'
import csv from '../../Assests/image/csv.svg'
import useButtonLoader from '../../hooks/UseButtonLoader'
import ModalBox from '../../components/modal/ModalBox'
import { useOTPModalCNF } from '../../hooks/useOTPModalCNF';
import ReactSelect from 'react-select';

const { USER_DETAIL, USER_DELETE } = user;
const { NOT_FOUND } = common;


// console.log('Gender', gender)

const MarketingManagement = () => {
  let URL = process.env.REACT_APP_API_URL
  const [searchParam, setSearchParam] = useSearchParams()
  let activePage = +searchParam.get('page') || 1
  const { open: openCNFModal, OTPModalCNF } = useOTPModalCNF();
  const [search, setSearch] = useState(
    getLocalStorage("userList", "search") || ""
  );
  const debounceValue = useDebounce(search || "", 300);
  const [total, setTotal] = useState(0);
  const [userList, setUserList] = useState([]);
  const [problemList, setProblemList] = useState([]);
  const [statusModal, setStatusModal] = useState(false);
  const [statusValue, setStatusValue] = useState("");
  const [statusId, setStatusId] = useState("");
  const [logoutUserModel, setLogoutUserModel] = useState(false);

  const [buttonref, buttonLoader] = useButtonLoader("Logout");
  const [consultationRange, setConsultationRange] = useState({ min: '', max: '' });
  const registrationStartDate = searchParam.get("registrationStartDate") || "";
  const registrationEndDate = searchParam.get("registrationEndDate") || "";
  const [startDate, setStartDate] = useState(registrationStartDate ? new Date(registrationStartDate) : null);
  const [endDate, setEndDate] = useState(registrationEndDate ? new Date(registrationEndDate) : null);
  const [walletRange, setWalletRange] = useState({ min: '', max: '' });
  const [selectedMode, setSelectedMode] = useState(null);
  const [selectedModeWallet, setSelectedModeWalllet] = useState(null);

  const [featureValue, setFeatureValue] = useState(() => {
    const val = searchParam.get("featureAccess");
    if (!val || val.trim() === "") return [];
    return val.split(",").filter(v => v.trim() !== "");
  });




  const [WriteOtpModal, setwriteOtpModal] = useState(false);
  const genderValue = searchParam.get("gender") || "";
  const consultationCountValue = searchParam.get("ConsultationCount") || "";
  // const [statusSearch, setStatusSearch] = useState('')
  const registrationDate = searchParam.get("registrationDate") || "";
  const [problemValue, setProblemValue] = useState(
    searchParam.get("problem")?.split(",") || []
  );




  // const [endDateSearch, setEndDateSearch] = useState('')

  useEffect(() => {
    setLocalStorage("userList", "search", search);
  }, [search]);

  const handleLogoutHandler = async () => {
    try {
      buttonLoader(true);
      const sendData = { userId: statusId };
      const { data } = await logoutUserFromAllDevice(sendData);
      if (data.code === 200) {
        console.log("Date", data);
        logoutCloseModel();
      } else {
        toastMessage(data.message, "error", "userList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      buttonLoader(false);
    }
  };

  // handle all hooks
  const { loading, requestDownload, DownloadPasswordModal } = useDownloadWithPassword();

  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const handleExcelDownload = () => {
    try {
      const url = `${URL}/admin/user/download`;
      const params = {};
      requestDownload(url, `user-excel-file-${dateFormat(new Date())}`, params);
    } catch (e) {
      console.log(e.message);
    }
  };
  //*********Handel status********* */
  const statusUpdateHandler = (id, status) => {
    setStatusModal(true);
    setStatusId(id);
    setStatusValue(status);
  };

  //*********Logout handler function********* */
  const userLogoutHandler = (id) => {
    setStatusId(id);
    setLogoutUserModel(true);
  };

  // gender handler

  const genderHandler = (value) => {
    if (genderValue === value) {
      searchParam.delete("gender");
    } else {
      searchParam.set("gender", value);
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
  };
  // Problem handler

  const problemValueHandler = (values) => {
    if (Array.isArray(values) && values.length > 0) {
      searchParam.set("problem", values.join(","));
    } else {
      searchParam.delete("problem");
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
  };


  const handleRangeSearch = () => {
    const { min, max } = consultationRange;
    if (min || max) {
      searchParam.set("consultationRange", JSON.stringify({ min, max }));
    } else {
      searchParam.delete("consultationRange");
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
  };

  // consultation count handler

  const TotalconsultationHandler = (value) => {
    if (consultationCountValue === value) {
      searchParam.delete("ConsultationCount");
    } else {
      searchParam.set("ConsultationCount", value);
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
  };

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };
  //*********Handel refresh icon********* */
  const refreshHandler = (event) => {
    setSearch("");
    searchParam.delete("page");
    searchParam.delete("gender");
    searchParam.delete("problem");
    searchParam.delete("registrationDate");
    searchParam.delete("ConsultationCount");
    setSearchParam(searchParam);
  };
  //------------------usre-listing-Api----------------------------------
  const getUserList = async (debounceValue) => {
    try {
      showLoader();
      const sendData = {
        page: `${activePage}`,
        limit: "10",
        filter: {}
      };

      if (debounceValue) {
        sendData.page = String(activePage)
        sendData.search = debounceValue
        // searchParam.delete('page')
        setSearchParam(searchParam)
      }
      if (problemValue.length > 0) {
        sendData.filter.problems = problemValue;
      }

      if (genderValue) {
        sendData.filter.gender = genderValue;
      }
      if (registrationDate) {
        sendData.filter.registerDate = registrationDate;
      }
      if (consultationCountValue) {
        sendData.consultationCountFilter = consultationCountValue;
      }
      if (featureValue.length > 0) {
        sendData.filter.featureAccess = featureValue;
      }
      if (selectedMode) {
        sendData.filter.selectedMode = selectedMode;
      }
      if(selectedModeWallet){
        sendData.filter.selectedModeWallet=selectedModeWallet;
      }
      const walletRangeParam = searchParam.get("walletRange");
      if (walletRangeParam) {
        try {
          const parsed = JSON.parse(walletRangeParam);
          const min = parsed.min !== '' ? Number(parsed.min) : undefined;
          const max = parsed.max !== '' ? Number(parsed.max) : undefined;

          if (min !== undefined || max !== undefined) {
            sendData.filter.walletRange = {};
            if (min !== undefined) sendData.filter.walletRange.min = min;
            if (max !== undefined) sendData.filter.walletRange.max = max;
          }
        } catch (e) {
          console.error("Invalid walletRange JSON:", walletRangeParam);
        }
      }



      const consultationRangeParam = searchParam.get("consultationRange");
      if (consultationRangeParam) {
        try {
          const parsed = JSON.parse(consultationRangeParam);

          const min = parsed.min !== '' ? Number(parsed.min) : undefined;
          const max = parsed.max !== '' ? Number(parsed.max) : undefined;

          if (min !== undefined || max !== undefined) {
            sendData.filter.consultationRange = {};
            if (min !== undefined) sendData.filter.consultationRange.min = min;
            if (max !== undefined) sendData.filter.consultationRange.max = max;
          }

        } catch (e) {
          console.error("Invalid consultationRange JSON:", consultationRangeParam);
        }
      }

      const registrationStartDate = searchParam.get("registrationStartDate");
      const registrationEndDate = searchParam.get("registrationEndDate");

      if (registrationStartDate || registrationEndDate) {
        sendData.filter.registerDateRange = {
          ...(registrationStartDate && { from: registrationStartDate }),
          ...(registrationEndDate && { to: registrationEndDate }),
        };
      }

      const { data } = await getUserListApimarketing(sendData);
      if (data.code === 200) {
        console.log('data ===>', data.result.list)
        console.log("remainingCoins ===>");
        data.result.list.map((user, index) => {
          console.log(`User ${index + 1}:`, user.remainingCoins);
        });
        setUserList(data?.result?.list || []);
        setTotal(data?.result?.total || 0);
        // scrollToUp();
      } else {
        setUserList([]);
        setTotal(0);
        toastMessage(data.message, "error", "userList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  const closeModel = () => {
    setStatusModal(false);
    setStatusValue("");
    setStatusId("");
  };

  const logoutCloseModel = () => {
    setLogoutUserModel(false);
    setStatusId("");
  };

  // problem list handler function

  const fetchProblemHandler = async () => {
    try {
      showLoader();
      const { data } = await fatchCategoryApi();
      if (data.code === 200) {
        setProblemList(data?.result?.categoryList || []);
        console.log('problemmmmmmmmm', data?.result?.categoryList, [], 2)
      } else {
        setProblemList([]);
        toastMessage(data.message, "error", "categoryList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };



  const handleRegistrationDate = (date) => {
    const utcDateString = dateFormatUtc(date);
    searchParam.delete("page");
    searchParam.set("registrationDate", utcDateString);
    setSearchParam(searchParam);
  };

  // useEffect(() => {
  //   if (debounceValue) {
  //     searchParam.set('query', debounceValue)
  //   } else {
  //     searchParam.delete('query')
  //   }
  //   if (activePage === 1) {
  //     searchParam.delete('page')
  //   }
  //   setSearchParam(searchParam)
  //   getOrder(activePage, debounceValue)
  // }, [searchParam, debounceValue])

  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParam.delete("page");
    }
    if (!genderValue) {
      searchParam.delete("gender");
    }
    if (!problemValue) {
      searchParam.delete("problem");
    }
    setSearchParam(searchParam);
    getUserList(debounceValue);
  }, [searchParam, debounceValue]);


  useEffect(() => {
    const walletRangeParam = searchParam.get("walletRange");
    if (walletRangeParam) {
      try {
        const parsed = JSON.parse(walletRangeParam);
        setWalletRange({
          min: parsed.min || '',
          max: parsed.max || ''
        });
      } catch (e) {
        console.error("Invalid walletRangeParam", walletRangeParam);
      }
    } else {
      setWalletRange({ min: '', max: '' });
    }
  }, [searchParam]);


  useEffect(() => {
    const consultationRangeParam = searchParam.get("consultationRange");
    if (consultationRangeParam) {
      try {
        const parsed = JSON.parse(consultationRangeParam);
        setConsultationRange({
          min: parsed.min || '',
          max: parsed.max || ''
        });
      } catch (e) {
        console.error("Invalid consultationRangeParam", consultationRangeParam);
      }
    } else {
      setConsultationRange({ min: '', max: '' });
    }
  }, [searchParam]);

  useEffect(() => {
    fetchProblemHandler();
  }, []);
  return (
    <>
      <OTPModalCNF verifiedHandle={() => {
        console.log('OTP Verified Successfully!')
      }} />
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            {/* <div className="user_management_heading"> */}
            <h4 className="Title">User Management</h4>
            <div className="block_user_button">
              <span
                className="user_management_excel"
                onClick={handleExcelDownload}
              >
                {loading ? (
                  <Loader />
                ) : (
                  <div className="csv-image-wrapper">
                    <figure>
                      <img src={csv} alt="csv file download" />
                    </figure>
                  </div>
                )}
              </span>
              {/* <div className="mx-2">
                <Link to={`${USER_DELETE}`}>
                  <div className="block_user_button">
                    <button
                    onClick={() => setAddConsultantModel(true)}
                    >
                      <AddIcon />
                      Deleted Userweddd
                    </button>
                  </div>
                </Link>
              </div> */}
            </div>
            {/* </div> */}
          </div>
          <div className="FilterBox FilterArea" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {/* Row 1 */}
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              {/* Search */}
              <div className="form-group search_lg_size userSearch">
                <input
                  type="search"
                  className={`form-control ${search && "active"}`}
                  placeholder="Search"
                  value={search || ""}
                  style={{ "--color": "#FF8989" }}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="user_search_icon">
                  <IoSearch />
                </span>
              </div>

              {/* Total Consultation */}
              <div className="form-group select_sm_width">
                <Select
                  className={`form-control ${ConsultationCount && "active"}`}
                  value={consultationCountValue || ""}
                  onChange={(e) => TotalconsultationHandler(e.target.value)}
                >
                  <option value="">Total Consultation</option>
                  {ConsultationCount?.map((item) => (
                    <option value={item.value} key={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </div>
              <div style={{marginTop:'-20px'}}>
                 <label style={{ marginBottom: 0 }}>Consultation Range</label>

            <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',gap:'16px'}}> 
               {/* Min */}
              <input
                type="number"
                placeholder="Min"
                value={consultationRange.min}
                onChange={(e) => {
                  const newMin = e.target.value;
                  const updated = { ...consultationRange, min: newMin };
                  setConsultationRange(updated);
                  const filterValue = {
                    min: newMin ? Number(newMin) : undefined,
                    max: updated.max ? Number(updated.max) : undefined
                  };
                  if (filterValue.min || filterValue.max) {
                    searchParam.set("consultationRange", JSON.stringify(filterValue));
                  } else {
                    searchParam.delete("consultationRange");
                  }
                  searchParam.delete("page");
                  setSearchParam(searchParam);
                }}
                className="form-control"
                style={{ width: '80px' }}
              />

              {/* Max */}
              <input
                type="number"
                placeholder="Max"
                value={consultationRange.max}
                onChange={(e) => {
                  const newMax = e.target.value;
                  const updated = { ...consultationRange, max: newMax };
                  setConsultationRange(updated);
                  const filterValue = {
                    min: updated.min ? Number(updated.min) : undefined,
                    max: newMax ? Number(newMax) : undefined
                  };
                  if (filterValue.min || filterValue.max) {
                    searchParam.set("consultationRange", JSON.stringify(filterValue));
                  } else {
                    searchParam.delete("consultationRange");
                  }
                  searchParam.delete("page");
                  setSearchParam(searchParam);
                }}
                className="form-control"
                style={{ width: '80px' }}
              /></div>
</div>

              {/* Registration Date */}
              {/* <div className="form-group date_picker">
                <DatePicker
                  className={`form-control ${registrationDate && "active"}`}
                  name="startDate"
                  selected={registrationDate}
                  placeholderText="Registration Date"
                  onChange={(date) => handleRegistrationDate(date)}
                  isClearable
                  maxDate={Date.now()}
                />
              </div> */}

              {/* Gender */}
              <div className="form-group select_sm_width" style={{marginLeft:'20px'}}>
                <Select
                  className={`form-control ${genderValue && "active"}`}
                  value={genderValue || ""}
                  onChange={(e) => genderHandler(e.target.value)}
                >
                  <option value="">Gender</option>
                  {gender?.map((g) => (
                    <option value={g.value} key={g.id}>
                      {g.name}
                    </option>
                  ))}
                </Select>
              </div>
            </div>

            {/* Row 2 */}
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
             
              {/* Problems Multi-Select */}
              <div style={{ width: '300px' }}>
                <ReactSelect
                  isMulti
                  className="form-control"
                  placeholder="Select Problem"
                  options={problemList.map((p) => ({ value: p._id, label: p.title }))}
                  value={problemList
                    .filter((p) => problemValue.includes(p._id))
                    .map((p) => ({ value: p._id, label: p.title }))}
                  onChange={(selectedOptions) => {
                    const selectedIds = selectedOptions.map((option) => option.value);
                    setProblemValue(selectedIds);
                    problemValueHandler(selectedIds);
                  }}
                />
              </div>
              {/* Kundali matchmaking access ,vastu ,meditation*/}
              <div style={{ width: '300px' }}>
                <ReactSelect
                  isMulti
                  placeholder="Select Feature Access"
                  options={[
                    { value: "Vastu", label: "Vastu" },
                    { value: "Kundali Matchmaking", label: "Kundali Matchmaking" },
                    { value: "Meditation", label: "Meditation" },
                  ]}
                  value={featureValue.map(v => ({ value: v, label: v }))}
                  onChange={(opts) => {
                    const vals = opts.map(o => o.value).filter(v => v.trim() !== "");
                    setFeatureValue(vals);
                    searchParam.set("featureAccess", vals.join(","));
                    setSearchParam(searchParam);
                  }}

                />

              </div>
              {/* Registration Date Range */}
              <div style={{ width: '270px'}}>
                <DatePicker
                  selectsRange
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    setStartDate(update[0]);
                    setEndDate(update[1]);

                    if (update[0]) {
                      searchParam.set("registrationStartDate", dateFormatUtc(update[0]));
                    } else {
                      searchParam.delete("registrationStartDate");
                    }

                    if (update[1]) {
                      searchParam.set("registrationEndDate", dateFormatUtc(update[1]));
                    } else {
                      searchParam.delete("registrationEndDate");
                    }

                    searchParam.delete("page");
                    setSearchParam(searchParam);
                  }}
                  isClearable
                  placeholderText="Select Registration Date Range"
                  className="form-control"
                  maxDate={new Date()}
                />
                <select
                  value={selectedMode || ""}
                  onChange={(e) => {
                    setSelectedMode(e.target.value);
                    searchParam.set("registrationDateMode", e.target.value); 
                    setSearchParam(searchParam);
                  }}
                  className="form-control"
                >
                  <option value="" disabled>Select</option> 
                  <option value="between">Between</option>
                  <option value="exact">Exact</option>
                  <option value="after">After</option>
                  <option value="before">Before</option>
                </select>


              </div>
              {/* wallet filter  */}
              <label style={{ marginBottom: 0 }}>Wallet Range</label>

              <input
                type="number"
                placeholder="Min"
                value={walletRange.min}
                onChange={(e) => {
                  const val = e.target.value;
                  const updated = { ...walletRange, min: val };
                  setWalletRange(updated);
                  const filter = {
                    min: val ? Number(val) : undefined,
                    max: updated.max ? Number(updated.max) : undefined,
                  };
                  if (filter.min || filter.max) {
                    searchParam.set("walletRange", JSON.stringify(filter));
                  } else {
                    searchParam.delete("walletRange");
                  }
                  searchParam.delete("page");
                  setSearchParam(searchParam);
                }}
                className="form-control"
                style={{ width: '80px' }}
              />

              <input
                type="number"
                placeholder="Max"
                value={walletRange.max}
                onChange={(e) => {
                  const val = e.target.value;
                  const updated = { ...walletRange, max: val };
                  setWalletRange(updated);
                  const filter = {
                    min: updated.min ? Number(updated.min) : undefined,
                    max: val ? Number(val) : undefined,
                  };
                  if (filter.min || filter.max) {
                    searchParam.set("walletRange", JSON.stringify(filter));
                  } else {
                    searchParam.delete("walletRange");
                  }
                  searchParam.delete("page");
                  setSearchParam(searchParam);
                }}
                className="form-control"
                style={{ width: '80px' }}
              />
              <select
                value={selectedModeWallet || ""}
                onChange={(e) => {
                  setSelectedModeWalllet(e.target.value);
                  searchParam.set("registrationDateMode", e.target.value);
                  setSearchParam(searchParam);
                }}
                className="form-control"
                style={{width:'200px'}}
              >
                <option value="" disabled>Select</option> 
                <option value="between">Between</option>
                <option value="exact">Exact</option>
                <option value="below">below</option>
                <option value="above">above</option>
              </select>
            </div>
          </div>

          <div className="content-table">
            <table>
              <thead>
                <tr>
                  <th>S. No.</th>
                  {/* <th>User Id</th> */}
                  {/* <th>Profile</th> */}
                  <th>Name</th>
                  <th>Phone Number</th>
                  <th>Date of Birth</th>
                  {/* <th>Status</th> */}
                  <th>Email</th>
                  {/* <th>Gender</th> */}
                  <th>Problem</th>
                  <th>Registration Date</th>
                  <th>Total Consultation</th>
                  <th>Wallet</th>
                  {/* <th>Kundali</th>
                  <th>Kundali Matchmaking</th>
                  <th>Vastu Compass</th>
                  <th>Meditation</th> */}
                  <th>Paid Consultation</th>
                  {/* <th>Free Consultation</th>
                  <th>Consultation/Week</th>
                  <th>Consultation/month</th> */}
                  <th>streaks</th>
                  {/* <th className="text-center"> Action </th>
                  <th>Logout from all Device</th> */}
                </tr>
              </thead>
              <tbody>
                {userList.length > 0 ? (
                  userList.map((user, index) => {
                    console.log("user ===>", user)
                    return (
                      <React.Fragment key={index}>
                        <tr>
                          <td>{findSerialNumber(index, activePage, 10)}</td>
                          {/* <td>{user?._id}</td> */}
                          {/* <td className="user_profile_image">
                            <img
                              src={user.profileImage || profileImage}
                              alt={`${user.name} profile image`}
                            />
                          </td> */}
                          <td>{user?.name || "---"}</td>
                          <td>{user.phone || "---"}</td>
                          <td>{dateFormat(user.dob) || "---"}</td>
                          <td>{user.email || "---"}</td>
                          <td>{user.problems?.join(', ') || '---'}</td>
                          <td>{dateFormat(user.createdAt) || "---"}</td>
                          <td>{user.totalConsultationCount || "---"}</td>
                          <td>{user.wallet ? user.wallet.toFixed(2) : '---'}</td>
                          {/* <td>{user.zodiac || '---'}</td>
                          <td>{user.matchmakingAccessed === true ? "Yes" : "No"}</td>
                          <td>{user.vastuAccessed === true ? "Yes" : "No"}</td>
                          <td>{user.meditationAccessed === true ? "Yes" : "No"}</td> */}
                          <td>{user.paidConsultationCount || '---'}</td>
                          {/* <td>{user?.freeConsultationCount || '---'}</td>
                          <td>{user?.consultationsPerWeek || '---'}</td>
                          <td>{user?.consultationsPerMonth || "---"}</td> */}
                          <td>{user.streak || '---'}</td>
                          {/* <td>
                            <div className="action_button">
                              <Link to={`${USER_DETAIL}/${user._id}`}>
                                <IconButton
                                  aria-label="update"
                                  className="px-2 py-0"
                                >
                                  <VisibilityIcon className="eye_icon" />
                                </IconButton>
                              </Link>

                              <Switch
                                checked={user.status}
                                onChange={() =>
                                  statusUpdateHandler(user._id, user.status)
                                }
                              />
                            </div>
                          </td> */}
                          {/* <td>
                            <div className="block_user_button">
                              <button
                                className="mx-4"
                                onClick={() => userLogoutHandler(user._id)}
                              // ref={buttonref}
                              >
                                Logout
                              </button>
                            </div>
                          </td> */}
                        </tr>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <NotFound
                    cols={9}
                    msg="User not found!"
                    icon={NOT_FOUND}
                    loader={loader}
                  />
                )}
              </tbody>
            </table>
          </div>
          {total > 10 ? (
            <div className="pagination-wrapper">
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={10}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                  hideDisabled={true}
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
      {statusModal && (
        <UserStatus
          show={statusModal}
          close={closeModel}
          setListing={setUserList}
          setUserDetail={""}
          status={statusValue}
          id={statusId}
        />
      )}

      {/* {logoutUserModel && (
        <ModalBox
          status={logoutUserModel}
          onClose={logoutCloseModel}
          title="Logout User from all Device"
          description="Do you want to logout the user from all the devices?"
          action={handleLogoutHandler}
          ref={buttonref}
        />
      )} */}

      <DownloadPasswordModal />
    </>
  );
};

export default MarketingManagement;
